import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Grid } from '@material-ui/core'

import { DashboardChartPaper, LineChart } from 'components'

import theme from 'theme'

import { PhishingProgressTable } from './components'
import useStyles from './styles'

const PhishingResultsChart = ({ stats, dailyStats, hasCourse }) => {
  const classes = useStyles()
  const { phishing: phishingColors } = theme.palette.dashboard.chart

  const delivered = stats?.delivered ?? 0
  const viewed = stats?.viewed ?? 0
  const clicks = stats?.clicks ?? 0
  const compromised = stats?.compromised ?? 0
  const completed = stats?.completed ?? 0

  const calcPercentage = (value) =>
    delivered === 0 ? 0 : Math.round((value / delivered) * 100)

  const rows = [
    {
      name: 'Entregues',
      value: delivered,
      percentage: calcPercentage(delivered),
      barClass: classes.barDelivered,
    },
    {
      name: 'Visualizados',
      value: viewed,
      percentage: calcPercentage(viewed),
      barClass: classes.barViewed,
    },
    {
      name: 'Cliques',
      value: clicks,
      percentage: calcPercentage(clicks),
      barClass: classes.barClicks,
    },
    {
      name: 'Comprometidos',
      value: compromised,
      percentage: calcPercentage(compromised),
      barClass: classes.barComprised,
    },
    ...(hasCourse
      ? [
          {
            name: 'Fizeram o curso',
            value: completed,
            percentage: calcPercentage(completed),
            barClass: classes.barCompleted,
          },
        ]
      : []),
  ]

  const hasEvolution = !isEmpty(dailyStats)

  const evolutionDates = hasEvolution
    ? dailyStats.map((day) => {
        const [, month, dayNumber] = day.date.split('-')
        return `${dayNumber}/${month}`
      })
    : []
  const evolutionSeries = hasEvolution
    ? [
        {
          name: 'Entregues',
          data: dailyStats.map((day) => day.delivered),
        },
        {
          name: 'Visualizados',
          data: dailyStats.map((day) => day.opened),
        },
        {
          name: 'Cliques',
          data: dailyStats.map((day) => day.clicked),
        },
        {
          name: 'Comprometidos',
          data: dailyStats.map((day) => day.compromised),
        },
      ]
    : []

  const chartColors = [
    phishingColors.delivered,
    phishingColors.viewed,
    phishingColors.clicks,
    phishingColors.compromised,
  ]

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <DashboardChartPaper
          title="Evolução da campanha"
          subtitle="Entregues, visualizados, cliques e comprometidos por dia"
        >
          <LineChart
            id="phishing-evolution-chart"
            categories={evolutionDates}
            series={evolutionSeries}
            height={250}
            colors={chartColors}
          />
        </DashboardChartPaper>
      </Grid>
      <Grid item xs={12} md={4}>
        <PhishingProgressTable title="Progressão por etapa" rows={rows} />
      </Grid>
    </Grid>
  )
}

PhishingResultsChart.propTypes = {
  stats: PropTypes.shape({
    delivered: PropTypes.number,
    viewed: PropTypes.number,
    clicks: PropTypes.number,
    compromised: PropTypes.number,
    completed: PropTypes.number,
  }),
  dailyStats: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      delivered: PropTypes.number,
      opened: PropTypes.number,
      clicked: PropTypes.number,
      compromised: PropTypes.number,
    }),
  ),
  hasCourse: PropTypes.bool,
}

export default PhishingResultsChart
